import React, { useEffect } from "react";
import MainPageHero from "../../components/MainPageHero/MainPageHero";
import FooterSubscribe from "../../components/Footer/FooterSubscribe";
import SaleBanner from "../../components/SaleBanner/SaleBanner";
import { CulturalEventsSection } from "../../components/CulturalEvents/CulturalEventsSection";
import "./HomePage.css";

function HomePage() {
  useEffect(() => {
    document.body.classList.add("home-page-active");
    return () => {
      document.body.classList.remove("home-page-active");
    };
  }, []);

  return (
    <div className="home-page">
      <MainPageHero backgroundImage="/images/main-page-img1-small.webp" />
      <FooterSubscribe />
      <SaleBanner />
      <CulturalEventsSection />
    </div>
  );
}

export default HomePage;

